import { render, staticRenderFns } from "./Block-Form-Single.vue?vue&type=template&id=1df64f17&scoped=true&"
import script from "./Block-Form-Single.vue?vue&type=script&lang=js&"
export * from "./Block-Form-Single.vue?vue&type=script&lang=js&"
import style0 from "./Block-Form-Single.vue?vue&type=style&index=0&id=1df64f17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df64f17",
  null
  
)

export default component.exports